export default __webpack_public_path__ + "static/media/logo.5025a034.png";